import React from 'react';
import type { SleepLog } from '../types';

interface SleepChartProps {
  logs: SleepLog[];
}

export const SleepChart: React.FC<SleepChartProps> = ({ logs }) => {
  const chartData = logs.slice(0, 7).reverse(); // Show last 7 days, in chronological order
  const maxDuration = Math.max(...chartData.map(log => log.duration), 8); // At least 8 hours for scale

  const qualityColors = ['#ef4444', '#f97316', '#eab308', '#84cc16', '#22c55e'];

  return (
    <div className="bg-slate-800 p-6 rounded-lg">
      <h3 className="text-lg font-bold text-slate-100 mb-4">Last 7 Days of Sleep</h3>
      <div className="flex justify-between items-end h-64 space-x-2">
        {chartData.map((log, index) => {
          const barHeight = (log.duration / maxDuration) * 100;
          const date = new Date(log.date);
           // Manually adjust for timezone to prevent off-by-one day errors
          const adjustedDate = new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1000);
          const day = adjustedDate.toLocaleDateString('en-US', { weekday: 'short' });
          const dayOfMonth = adjustedDate.getDate();

          return (
            <div key={index} className="flex-1 flex flex-col items-center justify-end h-full group">
              <div className="relative w-full h-full flex items-end justify-center">
                 <div
                    className="w-full rounded-t-md transition-all duration-300 group-hover:bg-indigo-400"
                    style={{ height: `${barHeight}%`, backgroundColor: qualityColors[log.quality - 1] }}
                  ></div>
                   <div className="absolute -top-6 text-xs bg-slate-900 px-2 py-1 rounded-md text-white opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                    {log.duration.toFixed(1)} hrs
                  </div>
              </div>
              <span className="text-xs text-slate-400 mt-2">{day}</span>
              <span className="text-xs text-slate-500">{dayOfMonth}</span>
            </div>
          );
        })}
      </div>
      <div className="flex items-center justify-center mt-4 space-x-4 text-xs text-slate-400">
        <span className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{backgroundColor: qualityColors[0]}}></div> Poor</span>
        <span className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{backgroundColor: qualityColors[2]}}></div> Okay</span>
        <span className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{backgroundColor: qualityColors[4]}}></div> Great</span>
      </div>
    </div>
  );
};